import React from 'react';

const ML_Training = () => {
    return (
        <div>ML_Training Component</div>
    );
}

export default ML_Training;
